import {AgentNewsApi} from 'Agent/AgentInformation/api';
import {AgentNewsFilter} from 'AgentNewsAdministration/models/AgentNewsFilter';
import {NewsEntry} from 'AgentNewsAdministration/models/News';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';

const agentNewsApi = new AgentNewsApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

export const getAgentNews = (filter?: AgentNewsFilter) =>
  withCancellation(cancelToken =>
    agentNewsApi.searchAgentNews('1', {
      params: {...filter},
      ...getAxiosConfig(cancelToken, false),
    })
  )
    .then(handleResponse)
    .then(E.map((pagedResultOfAgentNews): Page<NewsEntry> => (pagedResultOfAgentNews as unknown) as Page<NewsEntry>));

export const deleteAgentNewsEntry = (id: string) =>
  agentNewsApi.agentNewsDelete(id, '1', getAxiosConfig()).then(handleResponse);

export const addAgentNewsEntry = (newsEntry: NewsEntry) =>
  agentNewsApi
    .agentNewsAdd(
      '1',
      {
        title: newsEntry.title.value,
        description: newsEntry.description.value,
      },
      getAxiosConfig()
    )
    .then(handleResponse);

export const updateAgentNewsEntry = (id: string, newsEntry: NewsEntry) =>
  agentNewsApi
    .agentNewsUpdate(
      '1',
      {
        id,
        title: newsEntry.title.value,
        description: newsEntry.description.value,
      },
      getAxiosConfig()
    )
    .then(handleResponse);

export const getAgentNewsEntry = (id: string) =>
  agentNewsApi.agentNewsGet(id, '1', getAxiosConfig()).then(handleResponse);
